const SchedulePeriodFileType = {
    Document: 1,
    Image: 2,
    Video: 3,
};

const SchedulePeriodFileTypeArray = [
    { id: SchedulePeriodFileType.Document, name: "Documento" },
    { id: SchedulePeriodFileType.Image, name: "Imagem" },
    { id: SchedulePeriodFileType.Video, name: "Video" },
];

export { SchedulePeriodFileType, SchedulePeriodFileTypeArray };
